import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config.js'

export let tailwindVariables = resolveConfig(tailwindConfig)
